<template>
    <div>
        <span class="no-data" v-if="noData && detailsReady">Keine Daten vorhanden</span>
        <grid-layout ref="gridLayout" v-if="detailsReady && layoutReady && !noData"
                     :layout.sync="layout"
                     :is-draggable="this.isEditable"
                     :is-mirrored="false"
                     :prevent-collision="false"
                     :vertical-compact="false"
                     :autoSize="true"
                     :margin="[15, 15]"
                     :row-height="calcColWidth"
                     class="gridLayout"
                     @layout-updated="afterMovedCorrection"
                     :is-resizable="false"
                     :responsive="false"
                     :use-css-transforms="false"
                     :colNum="colNum"
        >
            <grid-item v-if="(findInLayout('revenue').visibility === 'extern' || isEditable )&& layoutReady"
                       :fixed="true"
                       :x="findInLayout('revenue').x"
                       :y="findInLayout('revenue').y"
                       :w="findInLayout('revenue').w"
                       :h="findInLayout('revenue').h"
                       :i="findInLayout('revenue').i"
                       :key="'draggable-'+findInLayout('revenue').i">
                <div class="chart">
                    <div class="chart-header"><span class="chart-header-text">Umsatz</span>
                        <ChartActionBar :editable="this.isEditable"
                                        @showComment="editComment('revenue')"
                                        :visibility="findInLayout('revenue').visibility"
                                        :comment="findInLayout('revenue').comment"
                                        :width="findInLayout('revenue').w"
                                        @toggleVisibility="toggleVisibility('revenue')"
                                        :resizeAllowed="false"></ChartActionBar>
                    </div>
                    <LineChart class="chart-wrapper" :width="lineWidth"  unit="€"
                               :digits="2" :height="lineHeight"
                               title="Revenue"
                               :labels="dates"
                               :data="getRevenue" type="big"></LineChart>
                </div>
            </grid-item>
            <grid-item v-if="(findInLayout('deal_type').visibility === 'extern' || isEditable) && layoutReady"
                       :fixed="true"
                       :x="findInLayout('deal_type').x"
                       :y="findInLayout('deal_type').y"
                       :w="findInLayout('deal_type').w"
                       :h="findInLayout('deal_type').h"
                       :i="findInLayout('deal_type').i"
                       :key="'draggable-'+findInLayout('deal_type').i">
                <div class="chart">
                    <div class="chart-header"><span class="chart-header-text">Dealart (nach Umsatz)</span>
                        <ChartActionBar :editable="this.isEditable"
                                        @showComment="editComment('deal_type')"
                                        :visibility="findInLayout('deal_type').visibility"
                                        :comment="findInLayout('deal_type').comment"
                                        @toggleVisibility="toggleVisibility('deal_type')"
                                        :resizeAllowed="false"></ChartActionBar>
                    </div>
                    <PieChart :digits="2" unit="€" class="chart-wrapper pie-wrapper" :labels="getDealTypeReporting.labels"
                              :data="getDealTypeReporting.data"
                              :height="pieDimensions" :width="pieDimensions"></PieChart>
                </div>
            </grid-item>
            <grid-item v-if="(findInLayout('impressions').visibility === 'extern' || isEditable )&& layoutReady"
                       :fixed="true"
                       :x="findInLayout('impressions').x"
                       :y="findInLayout('impressions').y"
                       :w="findInLayout('impressions').w"
                       :h="findInLayout('impressions').h"
                       :i="findInLayout('impressions').i"
                       :key="'draggable-'+findInLayout('impressions').i">
                <div class="chart">
                    <div class="chart-header"><span class="chart-header-text">Impressions</span>
                        <ChartActionBar :editable="this.isEditable"
                                        @showComment="editComment('impressions')"
                                        :visibility="findInLayout('impressions').visibility"
                                        :comment="findInLayout('impressions').comment"
                                        :width="findInLayout('impressions').w"
                                        @toggleVisibility="toggleVisibility('impressions')"
                                        :resizeAllowed="false"></ChartActionBar>
                    </div>
                    <LineChart unit="AIs" class="chart-wrapper" :width="lineWidth"
                               :height="lineHeight"
                               title="Impressions"
                               :labels="dates"
                               :data="getImpressions"
                               type="big"></LineChart>
                </div>
            </grid-item>
            <grid-item v-if="(findInLayout('format').visibility === 'extern' || isEditable) && layoutReady"
                       :fixed="true"
                       :x="findInLayout('format').x"
                       :y="findInLayout('format').y"
                       :w="findInLayout('format').w"
                       :h="findInLayout('format').h"
                       :i="findInLayout('format').i"
                       :key="'draggable-'+findInLayout('format').i">
                <div class="chart">
                    <div class="chart-header"><span class="chart-header-text">Format (nach Umsatz)</span>
                        <ChartActionBar :editable="this.isEditable"
                                        @showComment="editComment('format')"
                                        :visibility="findInLayout('format').visibility"
                                        :comment="findInLayout('format').comment"
                                        @toggleVisibility="toggleVisibility('format')"
                                        :resizeAllowed="false"></ChartActionBar>
                    </div>
                    <PieChart  :digits="2" unit="€" class="chart-wrapper pie-wrapper" :labels="getFormatReporting.labels"
                              :data="getFormatReporting.data"
                              :height="pieDimensions" :width="pieDimensions"></PieChart>
                </div>
            </grid-item>
          <!--  <grid-item v-if="(findInLayout('comment').visibility === 'extern' || isEditable) && layoutReady"
                       :fixed="true"
                       :x="findInLayout('comment').x"
                       :y="findInLayout('comment').y"
                       :w="findInLayout('comment').w"
                       :h="findInLayout('comment').h"
                       :i="findInLayout('comment').i"
                       :key="'draggable-'+findInLayout('comment').i">
                <div class="chart">
                    <text-box :customStyles="{height:'100%'}" @input="updateComment" :visibility="isEditable" :width="calcColWidth-15+'px'" :height="calcColWidth*0.9+'px'" header="Kommentar"
                              :text="getComment"></text-box>
                </div>
            </grid-item>-->
        </grid-layout>
        <Confirm title="Hinweis bearbeiten" :show="showDialog" @close="showDialog = false;"
                 @onok="confirmComment" @oncancel="deleteComment" :options="{confirm:{
                        title: 'Bestätigen',
                        icon: 'icon-apply'
                    },
                    cancel:{
                        title: 'Löschen',
                        icon: 'icon-delete'
                    }}">
            <textarea class="textarea-comment" rows="8" v-model="textAreaSingleComment" maxlength="300"></textarea>
        </Confirm>
    </div>
</template>

<script>
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import PieChart from "../../../components/charts/PieChart";
    import ChartActionBar from "./ChartActionBar";
    import VueGridLayout from 'vue-grid-layout';
    import LineChart from "../../../components/charts/LineChart";
    import Confirm from "../../../components/dialogs/Confirm";
    import Utils from "../../../scripts/utils";

    const PresetRepository = RepositoryFactory.get('presets');

    export default {
        name: "ChartGrid",
        components: {
            Confirm,
            LineChart,
            ChartActionBar,
            PieChart,
            GridLayout: VueGridLayout.GridLayout,
            GridItem: VueGridLayout.GridItem
        },
        data() {
            return {
                dateReady: false,
                layoutReady: false,
                showDialog: false,
                layout: [],
                pieDimensions:'0px',
                lineWidth:'0px',
                lineHeight:'0px',
                colNum: 9,
                allLayouts: [],
                layoutMatrix: [],
                textAreaSingleComment: '',
                textAreaSingleCommentIndex: -1,
                currentBreakPoint: 'lg',
                noData: false,
                validCharts: ['revenue', 'deal_type', 'impressions', 'format'],
                fnSaveDashboard: null,
                fnSaveDashboardHeader: null,
                detailsReady: false,
                comment: ''
            }
        },
        props: {
            isEditable: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.fnSaveDashboard = () => {
                this.saveDashboard(false);
            };
            this.fnSaveDashboardHeader = () => {
                this.saveDashboard(true);
            };
            this.calcPieDimensions();
            this.calcLineDimensions();
            window.addEventListener('resize',this.calcChartDimensions);
            this.$root.$on('saveDashboard', this.fnSaveDashboard);
            this.$root.$on('saveDashboardHeader', this.fnSaveDashboardHeader);
            this.$root.$on('rangeChange', this.dateReadyChange);
            this.$root.$on('dateChange', this.dateReadyChange);
            if (this.dates && this.dates.length > 0 && this.presetId ) {
                this.fetchDetails();
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.calcChartDimensions);
            this.$root.$off('saveDashboard', this.fnSaveDashboard);
            this.$root.$off('saveDashboardHeader', this.fnSaveDashboardHeader);
            this.$root.$off('rangeChange', this.dateReadyChange);
            this.$root.$off('dateChange', this.dateReadyChange);
        },
        computed: {
            vuexState() {
                return this.$store.state.deals;
            },
            details() {
                return this.$store.state.presets.currentDetails;
            },
            presetId() {
                return this.$store.state.presets.currentPreset ? this.$store.state.presets.currentPreset.id : null;
            },
            preset() {
                return this.$store.state.presets.currentPreset ? this.$store.state.presets.currentPreset : null;
            },
            calcColWidth() {
                return Utils.calcColWidth();
            },
            dates() {
                return this.vuexState.dates;
            },
            getRevenue() {
                let reporting = this.getReporting('revenue');
                if(reporting && !Array.isArray(reporting)){
                    reporting = [reporting];
                }
                return reporting ? reporting : [];
            },
            getDealTypeReporting() {
                let res = {labels: [], data: []};
                let reporting = this.getReporting('deal_type');
                for (let i = 0; i < reporting.length; i++) {
                    res.labels.push(reporting[i].deal_type);
                    res.data.push(reporting[i].brutto_revenue);
                }
                return res;
            },
            getImpressions() {
                let reporting = this.getReporting('impressions');
                if(reporting && !Array.isArray(reporting)){
                    reporting = [reporting];
                }
                return reporting ? reporting : [];
            },
            getFormatReporting() {
                let res = {labels: [], data: []};
                let reporting = this.getReporting('format');
                for (let i = 0; i < reporting.length; i++) {
                    res.labels.push(reporting[i].format);
                    res.data.push(reporting[i].brutto_revenue);
                }
                return res;
            }
        },
        watch: {
            detailsReady: function () {
                this.updateLayout()
            },
            presetId: function () {
                if (this.dates && this.dates.length > 0 && this.presetId ) {
                    this.fetchDetails();
                }
            }
        },
        created() {
            this.getCurrentBreakpoint();
            window.addEventListener('resize', this.getCurrentBreakpoint);
        },
        destroyed() {
            window.removeEventListener('resize', this.getCurrentBreakpoint);
        },
        methods: {
            calcChartDimensions(){
              this.calcLineDimensions();
              this.calcPieDimensions();
            },
            calcPieDimensions(){
                this.pieDimensions =  this.calcColWidth*0.7;
            },
            calcLineDimensions(){
                this.lineWidth = this.currentBreakPoint === 'lg' ? this.calcColWidth*2-60:this.calcColWidth;
                this.lineHeight = this.calcColWidth*0.8;
            },
            getReporting(name) {
                for (let i = 0; i < this.details.length; i++) {
                    if (this.details[i].name === name) {
                        return this.details[i].detail;
                    }
                }
                return null;
            },
            resizeChartGridItem(name) {
                try {
                    let initial = this.layoutMatrix[0].length;
                    this.layoutMatrix = this.transformMatrix(3);
                    this.syncMatrixWithLayoutReverse();
                    for (let i = 0; i < this.layout.length; i++) {
                        let nameTrue = false;
                        if (this.layout[i].name === name) {
                            nameTrue = true;
                        }
                        if (nameTrue) {
                            if (this.layout[i].w === 3) {
                                if (this.layout[i].x === 6) {
                                    this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3] = -1;
                                    this.layoutMatrix = this.moveRightFromPosition(this.layoutMatrix, 0, this.layout[i].y + 1, 2);
                                    this.layoutMatrix = this.correctMatrix(this.layoutMatrix);
                                    this.syncMatrixWithLayoutReverse();
                                    this.layout[i].x = 0;
                                    this.layout[i].y = this.layout[i].y + 1;
                                    this.layout[i].w = 6;
                                } else {
                                    this.layoutMatrix = this.moveRightFromPosition(this.layoutMatrix, this.layout[i].x / 3 + 1, this.layout[i].y, 1);
                                    this.layoutMatrix = this.correctMatrix(this.layoutMatrix);
                                    this.syncMatrixWithLayoutReverse();
                                    this.layout[i].w = 6;
                                }
                                this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3] = this.layout[i].i;
                                this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3 + 1] = this.layout[i].i;
                            } else {
                                this.layout[i].w = 3;
                                this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3 + 1] = -1;
                            }

                            let index = this.findIndexInDetails(this.layout[i].i);
                            this.details[index].pivot.chart_width = this.layout[i].w;
                            this.verticalCompact();
                        }
                    }
                    this.layoutMatrix = this.transformMatrix(initial);
                    this.syncMatrixWithLayoutReverse();
                }catch (e) {
                    console.log(e);
                }
            },
            toggleVisibility(name) {
                for (let i = 0; i < this.layout.length; i++) {
                    if (this.layout[i].name === name) {
                        this.layout[i].visibility = this.layout[i].visibility === "intern" ? "extern" : "intern";
                        this.details[this.layout[i].i].pivot.visibility = this.layout[i].visibility;
                        if(this.layoutReady){
                            this.$store.commit('presets/setChangesMade', true);
                        }
                        break;
                    }
                }
            },
            updateLayout() {
                this.layoutReady = false;
                this.layout = [];
                this.layoutMatrix = [];
                for (let k = 0; k < this.details.length; k++) {
                    if (this.validCharts.indexOf(this.details[k].name) !== -1 && (this.isEditable || this.details[k].pivot.visibility === 'extern')) {
                        if((this.currentBreakPoint === 'lg')&&(this.details[k].name==='revenue' || this.details[k].name === 'impressions')){
                            this.details[k].pivot.chart_width = 6;
                        }else if((this.currentBreakPoint !== 'lg')&&(this.details[k].name==='revenue' || this.details[k].name === 'impressions')){
                            this.details[k].pivot.chart_width = 3;
                        }
                        if (this.details[k].pivot.chart_width === 6) {
                            if (this.details[k].pivot.position_x / 3 !== 2) {

                                if (typeof this.layoutMatrix[this.details[k].pivot.position_y] === 'undefined') {
                                    this.layoutMatrix[this.details[k].pivot.position_y] = new Array(3).fill(-1);
                                }
                                if (this.layoutMatrix[this.details[k].pivot.position_y][this.details[k].pivot.position_x / 3] === -1 &&
                                    this.layoutMatrix[this.details[k].pivot.position_y][(this.details[k].pivot.position_x / 3) + 1] === -1) {
                                    let iNum = this.details[k].id;
                                    this.layoutMatrix[this.details[k].pivot.position_y][this.details[k].pivot.position_x / 3] = iNum;
                                    this.layoutMatrix[this.details[k].pivot.position_y][(this.details[k].pivot.position_x / 3) + 1] = iNum;
                                }
                            }
                        } else {
                            if (typeof this.layoutMatrix[this.details[k].pivot.position_y] === 'undefined') {
                                this.layoutMatrix[this.details[k].pivot.position_y] = new Array(3).fill(-1);
                            }
                            if (this.layoutMatrix[this.details[k].pivot.position_y][this.details[k].pivot.position_x / 3] === -1) {
                                let iNum = this.details[k].id;
                                this.layoutMatrix[this.details[k].pivot.position_y][this.details[k].pivot.position_x / 3] = iNum;
                            }
                        }
                    }
                }

                if (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
                    this.colNum = 3;
                    this.layoutMatrix = this.transformMatrix(1);
                } else if (this.currentBreakPoint === 'sm' || this.currentBreakPoint === 'md') {
                    this.layoutMatrix = this.transformMatrix(2);
                    this.colNum = 6;
                } else {
                    this.layoutMatrix = this.transformMatrix(3);
                    this.colNum = 9;
                }
                this.syncMatrixWithDetails();
                this.loadLayout();
                this.layoutReady = true;
            },
            loadLayout() {
                let layout = [];
                for (let i = 0; i < this.details.length; i++) {
                    if (this.validCharts.indexOf(this.details[i].name) !== -1 && (this.isEditable || this.details[i].pivot.visibility === 'extern')) {
                        let x = this.details[i].pivot.position_x / 3;
                        let y = this.details[i].pivot.position_y;
                        let iNum = this.details[i].id;
                        if (this.layoutMatrix[y][x] !== iNum) {
                            let positions = this.nextFreeMatrixPos(x, y, this.details[i].pivot.chart_width, iNum);
                            x = positions.x;
                            y = positions.y;
                        }
                        layout.push({
                            "name": this.details[i].name,
                            "x": x * 3,
                            "y": y,
                            "w": (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') ? 3 : this.details[i].pivot.chart_width,
                            "h": 1,
                            "i": iNum,
                            "visibility": this.details[i].pivot.visibility,
                            "comment": this.details[i].pivot.comment
                        })
                    }
                }
                this.layout = layout;
            },
            findIndexInLayout(name) {
                for (let i = 0; i < this.layout.length; i++) {
                    if (this.layout[i].name === name) {
                        return i;
                    }
                }
                return false;
            },
            findInLayout(name) {
                for (let i = 0; i < this.layout.length; i++) {
                    if (this.layout[i].name === name) {
                        return this.layout[i];
                    }
                }
                return {};
            },
            findLayoutIndexById(id) {
                for (let i = 0; i < this.layout.length; i++) {
                    if (this.layout[i].i === id) {
                        return i;
                    }
                }
                return {};
            },
            nextFreeMatrixPos(x, y, w, id) {
                if (w === 3 || this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
                    for (let i = 0; i < this.layoutMatrix.length; i++) {
                        for (let j = 0; j < this.layoutMatrix[i].length; j++) {
                            if (this.layoutMatrix[i][j] === -1) {
                                this.layoutMatrix[i][j] = id;
                                return {y: i, x: j};
                            }
                        }
                    }
                } else {
                    let filled = false;
                    let tmpI = 0;
                    let tmpJ = 0;
                    while (!filled) {
                        if (tmpJ === this.layoutMatrix.length) {
                            this.layoutMatrix[this.layoutMatrix.length] = new Array(this.layoutMatrix[0].length).fill(-1);
                            this.layoutMatrix[this.layoutMatrix.length - 1][0] = id;
                            this.layoutMatrix[this.layoutMatrix.length - 1][1] = id;
                            filled = true;
                            return {x: 0, y: this.layoutMatrix.length - 1};
                        }
                        if (this.layoutMatrix[tmpI][tmpJ] === -1 && this.layoutMatrix[tmpI][tmpJ + 1] === -1) {
                            this.layoutMatrix[tmpI][tmpJ] = id;
                            this.layoutMatrix[tmpI][tmpJ + 1] = id;
                            filled = true;
                            return {x: tmpJ, y: tmpI};
                        }
                        tmpJ++;
                        if (tmpJ === 2) {
                            tmpJ = 0;
                            tmpI++;
                        }

                    }
                }
                if (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
                    this.layoutMatrix[this.layoutMatrix.length] = new Array(1).fill(-1);
                }else if (this.currentBreakPoint === 'sm' || this.currentBreakPoint === 'md') {
                    this.layoutMatrix[this.layoutMatrix.length] = new Array(2).fill(-1);
                } else{
                    this.layoutMatrix[this.layoutMatrix.length] = new Array(3).fill(-1);
                }
                this.layoutMatrix[this.layoutMatrix.length - 1][0] = id;
                return {x: 0, y: this.layoutMatrix.length - 1};
            },
            afterMovedCorrection() {
                this.clearLayoutMatrix();
                for (let i = 0; i < this.layout.length; i++) {
                    if (this.layout[i].x < 3) {
                        this.layout[i].x = 0;
                    } else if (this.layout[i].x >= 3 && this.layout[i].x < 6) {
                        this.layout[i].x = 3;
                    } else {
                        this.layout[i].x = 6;
                    }
                    if (typeof this.layoutMatrix[this.layout[i].y] === 'undefined') {
                        this.layoutMatrix[this.layout[i].y] = new Array(this.layoutMatrix[0].length).fill(-1);
                    }
                    this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3] = this.layout[i].i;
                    if (this.layout[i].w === 6) {
                        this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3 + 1] = this.layout[i].i;
                    }
                }
                for (let j = 0; j < this.layoutMatrix.length; j++) {
                    if (typeof this.layoutMatrix[j] === 'undefined') {
                        this.layoutMatrix[j] = new Array(this.layoutMatrix[0].length).fill(-1);
                    }
                }
                this.verticalCompact();

            },
            clearLayoutMatrix() {
                for (let i = 0; i < this.layoutMatrix.length; i++) {
                    if (typeof this.layoutMatrix[i] !== 'undefined') {
                        for (let j = 0; j < this.layoutMatrix[i].length; j++) {
                            this.layoutMatrix[i][j] = -1;
                        }
                    }

                }
            },
            verticalCompact() {
                for (let i = 0; i < this.layoutMatrix.length; i++) {
                    for (let j = 0; j < this.layoutMatrix[i].length; j++) {
                        if (this.layoutMatrix[i][j] === -1) {
                            let nextFilled = this.findNextFilled(j, i);
                            if (!nextFilled) {
                                break;
                            }
                            let index = this.findLayoutIndexById(nextFilled.id);
                            if (this.layout[index].w === 3) {
                                this.layoutMatrix[i][j] = nextFilled.id;
                                this.layoutMatrix[nextFilled.y][nextFilled.x] = -1;
                                this.layout[index].y = i;
                                this.layout[index].x = j * 3;
                            } else if ((this.colNum === 9 && j * 3 !== 6)&&(this.colNum === 6 && j * 3 !== 3)) {
                                this.layoutMatrix[i][j] = nextFilled.id;
                                this.layoutMatrix[nextFilled.y][nextFilled.x] = -1;
                                this.layoutMatrix[i][j + 1] = nextFilled.id;
                                this.layoutMatrix[nextFilled.y][nextFilled.x + 1] = -1;
                                this.layout[index].y = i;
                                this.layout[index].x = j * 3;
                            }
                        }
                    }
                }
            },
            findNextFilled(x, y) {
                let xPos = x;
                let yPos = y;
                while (yPos !== this.layoutMatrix.length) {
                    if (this.layoutMatrix[yPos][xPos] !== -1) {
                        return {x: xPos, y: yPos, id: this.layoutMatrix[yPos][xPos]}
                    }
                    xPos++;
                    if (xPos >= this.layoutMatrix[yPos].length) {
                        yPos++;
                        xPos = 0;
                    }
                }
                return false;
            },
            editComment: function (detailName) {
                let index = this.findIndexInLayout(detailName);
                if (index !== false) {
                    this.textAreaSingleCommentIndex = index;
                    this.textAreaSingleComment = typeof this.layout[index].comment !== 'undefined' ? this.layout[index].comment : '';
                    this.showDialog = true;
                }


            },
            confirmComment: function () {
                this.showDialog = false;
                if (this.textAreaSingleCommentIndex !== -1) {
                    this.layout[this.textAreaSingleCommentIndex].comment = this.textAreaSingleComment;
                    if(this.layoutReady){
                        this.$store.commit('presets/setChangesMade', true);
                    }
                }

            },
            deleteComment: function () {
                this.showDialog = false;
                if (this.textAreaSingleCommentIndex !== -1) {
                    this.layout[this.textAreaSingleCommentIndex].comment = '';
                    if(this.layoutReady){
                        this.$store.commit('presets/setChangesMade', true);
                    }
                }

            },
            moveRightFromPosition(layoutMatrix, x, y, num) {
                for (let i = 0; i < num; i++) {
                    let yPos = y;
                    let xPos = x;
                    if (i !== 0) {
                        xPos++;
                        if (xPos > layoutMatrix[0].length - 1) {
                            yPos++;
                            if (typeof layoutMatrix[yPos] === 'undefined') {
                                layoutMatrix[yPos] = new Array(layoutMatrix[0].length).fill(-1);
                            }
                            xPos = xPos - layoutMatrix[0].length;
                        }
                    }

                    let valueCache = null;
                    while (valueCache !== -1) {
                        let nextX = xPos + 1;
                        let nextY = yPos;
                        if (nextX > layoutMatrix[0].length - 1) {
                            nextY++;
                            if (typeof layoutMatrix[nextY] === 'undefined') {
                                layoutMatrix[nextY] = new Array(layoutMatrix[0].length).fill(-1);
                            }
                            nextX = nextX - layoutMatrix[0].length;
                        }
                        if (valueCache !== null) {
                            let tmp = layoutMatrix[nextY][nextX];
                            layoutMatrix[nextY][nextX] = valueCache;
                            valueCache = tmp;
                        } else {
                            valueCache = layoutMatrix[nextY][nextX];
                            layoutMatrix[nextY][nextX] = layoutMatrix[yPos][xPos];
                            layoutMatrix[yPos][xPos] = -1
                        }
                        xPos++;
                        if (xPos > layoutMatrix[0].length - 1) {
                            xPos = 0;
                            yPos++;
                            if (typeof layoutMatrix[yPos] === 'undefined') {
                                layoutMatrix[yPos] = new Array(layoutMatrix[0].length).fill(-1);
                            }
                        }
                    }
                }
                return layoutMatrix;
            },
            syncMatrixWithLayoutReverse() {
                for (let i = this.layoutMatrix.length - 1; i >= 0; i--) {
                    if (typeof this.layoutMatrix[i] !== 'undefined') {
                        for (let j = this.layoutMatrix[i].length - 1; j >= 0; j--) {
                            if (this.layoutMatrix[i][j] !== -1) {
                                let index = this.findLayoutIndexById(this.layoutMatrix[i][j])
                                this.layout[index].x = j * 3;
                                this.layout[index].y = i;
                            }
                        }
                    }

                }
            },
            syncMatrixWithDetails() {
                let lastVal = -1;
                for (let i = 0; i < this.layoutMatrix.length; i++) {
                    if (typeof this.layoutMatrix[i] !== 'undefined') {
                        for (let j = 0; j < this.layoutMatrix[i].length; j++) {
                            if (lastVal !== -1 && this.layoutMatrix[i][j] === lastVal) {
                                lastVal = this.layoutMatrix[i][j];
                                continue;
                            }
                            let index = this.findIndexInDetails(this.layoutMatrix[i][j]);
                            if (index !== -1) {
                                this.details[index].pivot.position_x = j * 3;
                                this.details[index].pivot.position_y = i;
                            }
                            lastVal = this.layoutMatrix[i][j];
                        }
                    }
                }
            },
            findInDetails(id) {
                for (let i = 0; i < this.details.length; i++) {
                    if (this.details[i].id === id) {
                        return this.details[i];
                    }
                }
                return {};
            },
            findIndexInDetails(id) {
                for (let i = 0; i < this.details.length; i++) {
                    if (this.details[i].id === id) {
                        return i;
                    }
                }
                return -1;
            },
            async saveDashboard(clickedFromHeader) {
                try {
                    clickedFromHeader ? this.$root.$emit('dashboardLoader', true) : this.savingDashboard = true;
                    let allDetails = [];
                    for (let i = 0; i < this.layout.length; i++) {
                        let layout = this.layout[i];
                        let details = this.findInDetails(this.layout[i].i);
                        details.pivot.position_x = this.layout[i].x;
                        details.pivot.position_y = this.layout[i].y;
                        details.pivot.chart_width = this.layout[i].w;
                        details.pivot.visibility = layout.visibility;
                        details.pivot.comment = typeof this.layout[i].comment !== 'undefined' ? this.layout[i].comment : '';
                        allDetails.push(details);
                    }
                    await PresetRepository.updatePresetDetails(this.presetId, {
                        details: allDetails,
                        preset:this.preset
                    });
                    this.$noty.success('Dashboard erfolgreich gespeichert');
                } catch (e) {
                    this.$noty.error(e);
                    console.log(e)
                }
                clickedFromHeader ? this.$root.$emit('dashboardLoader', false) : this.$root.$emit('saveDashboardFinished',true);
                this.fetchDetails();
            },
            getCurrentBreakpoint() {
                let reload = false;
                if (window.innerWidth >= 1200) {
                    if (this.currentBreakPoint !== 'lg') {
                        reload = true;
                    }
                    this.currentBreakPoint = 'lg';
                } else if (window.innerWidth >= 996) {
                    if (this.currentBreakPoint !== 'md') {
                        reload = true;
                    }
                    this.currentBreakPoint = 'md';
                } else if (window.innerWidth >= 768) {
                    if (this.currentBreakPoint !== 'sm') {
                        reload = true;
                    }
                    this.currentBreakPoint = 'sm';
                } else if (window.innerWidth >= 480) {
                    if (this.currentBreakPoint !== 'xs') {
                        reload = true;
                    }
                    this.currentBreakPoint = 'xs';
                } else {
                    if (this.currentBreakPoint !== 'xxs') {
                        reload = true;
                    }
                    this.currentBreakPoint = 'xxs';
                }
                if (reload && this.layoutReady) {
                    this.layoutReady = false;
                    if (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
                        this.colNum = 3;
                        this.layoutMatrix = this.transformMatrix(1);
                    } else if (this.currentBreakPoint === 'sm' || this.currentBreakPoint === 'md') {
                        this.layoutMatrix = this.transformMatrix(2);
                        this.colNum = 6;
                    } else {
                        this.layoutMatrix = this.transformMatrix(3);
                        this.colNum = 9;
                    }
                    this.syncMatrixWithDetails();
                    this.loadLayout();
                    this.layoutReady = true;
                }

            },
            listToMatrix(list, elementsPerSubArray) {
                let matrix = [], i, k;
                for (i = 0, k = -1; i < list.length; i++) {
                    if (i % elementsPerSubArray === 0) {
                        k++;
                        matrix[k] = [];
                    }
                    matrix[k].push(list[i]);
                }
                if (matrix.length > 0) {
                    while (matrix[matrix.length - 1].length !== elementsPerSubArray) {
                        matrix[matrix.length - 1].push(-1);
                    }
                } else {
                    this.noData = true;
                }
                return matrix;
            },
            transformMatrix(colums) {
                this.noData = false;
                let list = [];
                for (let i = 0; i < this.layoutMatrix.length; i++) {
                    if (typeof this.layoutMatrix[i] !== 'undefined') {
                        list = list.concat(this.layoutMatrix[i]);
                    }
                }
                list = [...new Set(list)];
                if (colums > 1) {
                    for (let i = 0; i < list.length; i++) {
                        if (list[i] !== -1 && this.findInDetails(list[i]).pivot.chart_width === 6) {
                            list.splice(i, 0, list[i]);
                            i++;
                        }
                    }
                }
                for (let i = 0; i < list.length; i++) {
                    if (list[i] === -1) {
                        list.splice(i, 1);
                        i--;
                    }
                }
                let newMatrix = this.listToMatrix(list, colums);
                if (colums > 1) {
                    newMatrix = this.correctMatrix(newMatrix);
                }
                return newMatrix;
            },
            correctMatrix(matrix) {
                let lastInLine = -1;
                let firstInLine = -1;
                for (let i = 0; i < matrix.length; i++) {
                    firstInLine = matrix[i][0];
                    if (firstInLine === lastInLine && lastInLine !== -1) {
                        matrix = this.moveRightFromPosition(matrix, matrix[i - 1].length - 1, i - 1, 1);
                        matrix[i - 1][matrix[i - 1].length - 1] = -1;
                    }
                    lastInLine = matrix[i][matrix[i].length - 1];
                }
                return matrix;
            },
            async fetchDetails() {
                this.$emit('loadingStarted');
                this.detailsReady = false;
                await this.$store.dispatch('presets/fetchDetails', {
                    preset_id: this.presetId,
                    dates: this.dates,
                    presetColumns: this.$store.state.presets.tmpFilterData ? this.$store.state.presets.tmpFilterData : this.$store.state.presets.currentPresetColumns
                });
                this.detailsReady = true
                this.$emit('loadingFinished');
            },
            dateReadyChange(){
                this.dateReady = true;
                this.fetchDetails();
            }
        }
    }
</script>

<style scoped lang="scss">
    .gridLayout {
        margin-right: -15px;
        margin-left: -15px;
        margin-top: -15px;
    }

    .chart {
        margin-top: 1rem;
        display: inline-block;
        height: 100%;
        width: 100%;
        text-align: center;
        background-color: #fff;
    }

    .chart-header {
        font-weight: bold;
        padding: 1rem;
        height: 3rem;
        position: absolute;
        width: 100%;
    }

    .chart-header-text {
        float: left;
        font-size: 1em;
    }

    .chart-wrapper {
      //  padding-left: 15px;
        margin-top: 3rem;
    }

    .modal-container {
        padding: 2.1em !important;
    }

    .textarea-comment {
        width: 90%;
    }

    @media (max-width: 767px) {
        .gridLayout {
            margin-right: -30px;
            margin-left: -30px;
        }

        canvas {
            width: 100%;
            height: 100%;
        }
    }

    .no-data {
        display: block;
        width: 12rem;
        margin: auto;
        padding-top: 3rem;
        font-weight: bold;
    }

    .loaderContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 10em;
    }

    .pie-wrapper{
        margin-top: 3.5rem;
    }


    .kpi-box{
        background-color: #fff;
    }

    .middle-kpi{
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .kpi-box-wrapper{
        background-color: unset !important;
        padding: 0!important;
    }

    .transparent{
        background-color: unset ;
    }

    .positive{
        color:#009AA6;
        font-size: 0.8em;
        margin-top: 1rem;
    }

    .negative{
        color:#FF001A;
        font-size: 0.8em;
        margin-top: 1rem;
    }

    .header{
        font-weight: bold;
        margin-bottom: 1.5rem;
    }
</style>